import { render, staticRenderFns } from "./SelectProjectTemplate.vue?vue&type=template&id=47e8f137&scoped=true"
import script from "./SelectProjectTemplate.vue?vue&type=script&lang=js"
export * from "./SelectProjectTemplate.vue?vue&type=script&lang=js"
import style0 from "./SelectProjectTemplate.vue?vue&type=style&index=0&id=47e8f137&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e8f137",
  null
  
)

export default component.exports